// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const WalletAdd1Icon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "WalletAdd1/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9.95 1.842 7.942 6.517H5.933c-.333 0-.658.025-.975.091l.834-2 .033-.075.05-.133c.025-.058.042-.108.067-.15.966-2.242 2.05-2.942 4.008-2.408ZM15.608 6.742l-.016-.009a5.573 5.573 0 0 0-1.525-.216H8.85l1.875-4.359.025-.058c.117.042.242.1.367.142l1.841.775c1.025.425 1.742.866 2.184 1.4.075.1.141.191.208.3.075.116.133.233.167.358.033.075.058.142.075.217.125.425.133.908.016 1.45ZM15.242 7.933a4.215 4.215 0 0 0-1.175-.166H5.933c-.566 0-1.1.108-1.6.325a4.078 4.078 0 0 0-2.466 3.741v1.625c0 .2.016.392.041.592.184 2.65 1.6 4.067 4.25 4.242.192.025.384.041.592.041h6.5c3.083 0 4.708-1.466 4.867-4.383.008-.158.016-.325.016-.492v-1.625a4.083 4.083 0 0 0-2.891-3.9Zm-3.159 5.559h-1.458V15a.63.63 0 0 1-.625.625.63.63 0 0 1-.625-.625v-1.508H7.917a.624.624 0 1 1 0-1.25h1.458v-1.409a.63.63 0 0 1 .625-.625.63.63 0 0 1 .625.625v1.409h1.458a.624.624 0 1 1 0 1.25Z"
}));
export default WalletAdd1Icon;